<div class="row">
    <div class="col-md-3 col-12">
        <div class="card">
            <div class="card-header">
                <div class="card-title mb-0">User</div>
            </div>
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <div class="mb-3">
                        <label for="name" class="form-label">Name <em>*</em></label>
                        <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.name" required autocomplete="off">
                        <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                            <div *ngIf="name.errors.required">Name is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="username" class="form-label">Login Username <em>*</em></label>
                        <input type="text" class="form-control" maxlength="12" id="username" name="username" #username="ngModel" [(ngModel)]="data.username" required autocomplete="off" [readonly]="data.uuid">
                        <div *ngIf="f.submitted && username.invalid" class="invalid-feedback">
                            <div *ngIf="username.errors.required">Username is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Login Password <em>*</em></label>
                        <input type="password" maxlength="12" class="form-control" id="password" name="password" #password="ngModel" [(ngModel)]="data.password" required autocomplete="off">
                        <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                            <div *ngIf="password.errors.required">Password is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="title" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="is_mario">
                        <label for="is_admin" class="form-label">Is Admin <em>*</em></label>
                        <select class="form-control" name="is_admin" #is_admin="ngModel" [(ngModel)]="data.is_admin" required>
                            <option [value]="0">No</option>
                            <option [value]="1">Yes</option>
                        </select>
                        <div *ngIf="f.submitted && is_admin.invalid" class="invalid-feedback">
                            <div *ngIf="is_admin.errors.required">Is admin is required</div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>